import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { ISupplierContact } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'
import { Contact } from '~/cynqueModules/dataObjects/Contact'

const apiEntityPath = '/api/suppliercontacts'

export async function getSupplierContacts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getSupplierContacts.name
  return httpGet<ISupplierContact[]>({ callingMn, apiPath })
}

export async function getSupplierContactsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getSupplierContacts.name
  const rawSupplierContacts = await httpGet<ISupplierContact[]>({
    callingMn,
    apiPath,
  })
  return rawSupplierContacts.map((rawSupplierContact) =>
    Contact(rawSupplierContact)
  )
}

export async function createSupplierContact(entity: ISupplierContact) {
  const callingMn = createSupplierContact.name
  const apiPath = apiEntityPath
  return httpPost<ISupplierContact>({ callingMn, apiPath, entity })
}

export async function updateSupplierContact(
  entityData: Partial<ISupplierContact>,
  id: TEntityId
) {
  const callingMn = updateSupplierContact.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialISupplierContact = Partial<ISupplierContact>
  return httpPatchMerge<TPartialISupplierContact>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteSupplierContact(entityData: ISupplierContact) {
  const callingMn = deleteSupplierContact.name
  const apiPath = apiEntityPath
  return httpDelete<ISupplierContact>({
    callingMn,
    apiPath,
    entityData,
  })
}
